export default __webpack_public_path__ + "static/media/deer_creek_500.339b79af.webp";